import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import styles from "./styles.module.scss";
import globalColors from "../../../_metronic/_assets/sass/custom/globalColors.scss";
import pt from "date-fns/locale/pt-BR";

const InputDateForm = ({
  name,
  placeholder,
  onChange,
  label,
  isDisabled,
  height,
  isClearable = true,
  withPortal = false,
  selectedDate,
}) => {
  const handleDateChange = (date) => {
    setStartDate(date)
    onChange(date);
  };
  const [startDate, setStartDate] = useState();

  return (
    <div className={`${styles.inputContainer}`}

    >
      <div style={{ height: height }}
        className={`
        ${styles.divInput} ${isDisabled ? styles.isDisabled : ""} `}

      >
        <label htmlFor={name}
          style={{
            color: `${isDisabled ? `${globalColors.primaryColor6}` : globalColors.textColor2}`
            , padding: "0 5px",
            backgroundColor: globalColors.colorWhite,
            zIndex: 1,
          }}
        >
          {label}
        </label>
        <DatePicker
          locale={pt}
          selected={selectedDate === undefined ? startDate : selectedDate}
          onChange={handleDateChange}
          disabled={isDisabled}
          placeholderText={placeholder}
          isClearable={isClearable}
          withPortal={withPortal}
          dateFormat="dd/MM/yyyy"
          name={name}
          className={`
            ${styles.input} 
            ${isDisabled ? styles.isDisabled : ""} 
       `
          }
        />
      </div>
    </div>
  );
};

export default InputDateForm;
